import { useState } from "react";
import { SendHorizontal } from "lucide-react";
import TaskEmployees from "../../ui/TaskEmployees";
import { useEmployees, useTotalStaff } from "../../Use-auth";
import { useAddLeadsComment } from "../../Use-auth";

function AddCommentInput({ lead, updateLead, refetch, currentUser, setShowPopup }) {
    const [newComment, setNewComment] = useState("");
    const { data: totalStaff } = useTotalStaff();
    const [assignedEmployeeIds, setAssignedEmployeeIds] = useState([]);
    const adddComment = useAddLeadsComment();

    const employees = (totalStaff || [])
        .filter(
            (emp) =>
                emp.departmentName === "Sales" ||
                emp.departmentName === "Management" ||
                emp.departmentName === "Admin"
        );

    const isSales = employees;

    const handleAddComment = () => {
        if (!newComment.trim()) return;

        adddComment.mutate(
            {
                leadId: lead._id,
                comment: newComment.trim(),
                userId: currentUser.userId,
                userName: currentUser.fullName,
                assignedUserIds: assignedEmployeeIds,
            },
            {
                onSuccess: async () => {
                    setNewComment("");

                    const fresh = await refetch();

                    const latestLead = fresh?.data?.data?.find(
                        (l) => l._id === lead._id
                    );

                    if (latestLead) {
                        setShowPopup(latestLead);
                    }
                },
                onError: (err) => {
                    console.error("Add Comment Error:", err);
                },
            }
        );
    };

    return (
        <div className="w-full flex items-end gap-2 bg-gray-50 border rounded-xl p-2 sm:p-3 shadow-sm">
            <TaskEmployees
                employees={isSales}
                className="comment-dropdown"
                placement="top"
                align="left"
                onChange={(ids) => {
                    if (!ids?.length) return;

                    const selected = ids.map((id) => {
                        const emp = employees.find((e) => e.employeeId === id);

                        if (!emp) return null;

                        return {
                            userId: emp.employeeId,
                            name: `@${emp.firstName} ${emp.lastName || ""}`.trim(),
                        };
                    }).filter(Boolean);

                    setAssignedEmployeeIds((prev) => {
                        const newIds = selected
                            .map((s) => s.userId)
                            .filter(Boolean);

                        return Array.from(new Set([...prev, ...newIds]));
                    });

                    const names = selected.map((s) => s.name).join(" ");
                    setNewComment((prev) => (prev ? prev + " " + names : names));
                }}
            />

            <textarea
                className="flex-1 border border-gray-300 rounded-lg px-2 py-1 sm:px-3 sm:py-2 text-sm
  leading-5 min-h-[28px] sm:min-h-[36px]
  focus:outline-none focus:ring-2 focus:ring-blue-400
  placeholder-gray-400 bg-white resize-none overflow-hidden"
                rows={1}
                placeholder="Write a comment..."
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
                onInput={(e) => {
                    e.target.style.height = "auto";
                    e.target.style.height = e.target.scrollHeight + "px";
                }}
            />

            <button
                onClick={handleAddComment}
                disabled={!newComment.trim()}
                className=" h-7 w-7 sm:h-9 sm:w-9 flex items-center justify-center
             bg-blue-600 text-white rounded-md
             hover:bg-blue-700 transition disabled:opacity-50"
            >
                <SendHorizontal className="w-4 h-4 sm:w-6 sm:h-6 " />
            </button>
        </div>
    );
}

export default AddCommentInput;